var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cog-picker cog-select cog-input",
      class: {
        "is-read-only": _vm.readonly,
        "cog-picker--allow-other": _vm.internalAllowOther
      }
    },
    [
      _vm.readonly
        ? [
            _c(
              "span",
              { class: { "cog-image-item": _vm.selectedImage.value } },
              [
                _vm.selectedImage.value
                  ? [
                      !_vm.isSvg(_vm.selectedImage.value) &&
                      _vm.selectedImage.type === "image"
                        ? _c("img", {
                            staticClass: "cog-lookup-image cog-avatar",
                            attrs: {
                              src: _vm.selectedImage.value,
                              alt: "",
                              height: "50",
                              width: "50"
                            }
                          })
                        : _vm.selectedImage.type === "choiceImage"
                        ? _c("div", {
                            staticClass: "cog-choice-image",
                            style: {
                              backgroundImage: `url(${_vm.selectedImage.value})`
                            },
                            attrs: { height: "50", width: "50" }
                          })
                        : _c("c-generated-avatar", {
                            staticClass: "cog-select-image__prefix",
                            attrs: { svg: _vm.selectedImage.value }
                          })
                    ]
                  : _vm._e(),
                _vm._v(_vm._s(_vm.displayValue || " "))
              ],
              2
            )
          ]
        : [
            _vm.useNative
              ? _c(
                  "c-picker-native",
                  {
                    attrs: {
                      placeholder: _vm.placeholder,
                      "show-placeholder": !_vm.hidePlaceholder
                    },
                    scopedSlots: _vm._u(
                      [
                        _vm.mobile && _vm.showSelectIcon
                          ? {
                              key: "icon",
                              fn: function() {
                                return [_c("i-chevron")]
                              },
                              proxy: true
                            }
                          : null
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _vm.internalAllowOther
                      ? [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.internalValue,
                                expression: "internalValue"
                              }
                            ],
                            staticClass: "el-input__inner",
                            attrs: {
                              id: _vm.id ? "cog-" + _vm.id : null,
                              type: "text",
                              list: _vm.id ? `cog-${_vm.id}-list` : null,
                              placeholder: _vm.placeholder
                            },
                            domProps: { value: _vm.internalValue },
                            on: {
                              keydown: _vm.handleNativeMenuOpen,
                              click: _vm.handleNativeMenuOpen,
                              change: _vm.handleNativeChange,
                              focus: _vm.handleFocus,
                              blur: _vm.handleBlur,
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.internalValue = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "datalist",
                            {
                              attrs: {
                                id: _vm.id ? `cog-${_vm.id}-list` : null
                              }
                            },
                            [
                              _vm.showEmptyOption
                                ? _c("option", { domProps: { value: null } }, [
                                    _vm._v(" ")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.options, function(item) {
                                return _c(
                                  "option",
                                  {
                                    key: item.value,
                                    domProps: { value: item.value }
                                  },
                                  [_vm._v(_vm._s(item.displayValue))]
                                )
                              })
                            ],
                            2
                          )
                        ]
                      : _c(
                          "select",
                          _vm._b(
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.internalValue,
                                  expression: "internalValue"
                                }
                              ],
                              ref: "nativeSelect",
                              staticClass: "el-input__inner",
                              class: { "is-null": !_vm.value },
                              attrs: {
                                id: _vm.id ? "cog-" + _vm.id : null,
                                title: _vm.title
                              },
                              on: {
                                keydown: _vm.handleNativeMenuOpen,
                                click: _vm.handleNativeMenuOpen,
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.internalValue = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  _vm.handleNativeChange
                                ],
                                focus: _vm.handleFocus,
                                blur: _vm.handleBlur
                              }
                            },
                            "select",
                            _vm.$attrs,
                            false
                          ),
                          [
                            _vm.showEmptyOption
                              ? _c("option", { domProps: { value: null } }, [
                                  _vm._v(" ")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.options, function(item) {
                              return _c(
                                "option",
                                {
                                  key: item.value,
                                  domProps: { value: item.value }
                                },
                                [_vm._v(_vm._s(item.displayValue))]
                              )
                            })
                          ],
                          2
                        )
                  ],
                  2
                )
              : _c(
                  "el-select",
                  _vm._b(
                    {
                      ref: "select",
                      attrs: {
                        id: _vm.id ? "cog-" + _vm.id : null,
                        placeholder: _vm.placeholder,
                        "allow-create": _vm.internalAllowOther,
                        "no-data-text": " ",
                        "default-first-option": "",
                        filterable: _vm.filterable,
                        "filter-match": _vm.filterMatch,
                        "alternative-filter": _vm.alternativeFilter,
                        editable: _vm.internalAllowOther,
                        "automatic-dropdown": false,
                        "popper-class": _vm.popperClasses,
                        autocomplete: _vm.autocomplete,
                        title: _vm.title,
                        "lazy-options": ""
                      },
                      on: {
                        focus: _vm.handleFocus,
                        blur: _vm.handleBlur,
                        change: _vm.handleChange,
                        "visible-change": _vm.handleSelectVisibleChange
                      },
                      nativeOn: {
                        change: function($event) {
                          return _vm.handleUserInputChange.apply(
                            null,
                            arguments
                          )
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          !_vm.prefixDefined &&
                          _vm.selectedImage.value &&
                          !_vm.dropdownVisible
                            ? {
                                key: "prefix",
                                fn: function() {
                                  return [
                                    !_vm.isSvg(_vm.selectedImage.value) &&
                                    _vm.selectedImage.type === "image"
                                      ? _c("img", {
                                          staticClass:
                                            "cog-lookup-image cog-avatar cog-select-image__prefix",
                                          attrs: {
                                            src: _vm.selectedImage.value,
                                            alt: "",
                                            height: "50",
                                            width: "50"
                                          }
                                        })
                                      : _vm.selectedImage.type === "choiceImage"
                                      ? _c("div", {
                                          staticClass:
                                            "cog-choice-image cog-select-image__prefix",
                                          style: {
                                            backgroundImage: `url(${_vm.selectedImage.value})`
                                          },
                                          attrs: { height: "50", width: "50" }
                                        })
                                      : _c("c-generated-avatar", {
                                          staticClass:
                                            "cog-select-image__prefix",
                                          attrs: {
                                            svg: _vm.selectedImage.value
                                          }
                                        })
                                  ]
                                },
                                proxy: true
                              }
                            : null,
                          _vm.showSelectIcon
                            ? {
                                key: "suffix",
                                fn: function() {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: _vm.handleIconClick,
                                          mousedown: _vm.handleIconMousedown
                                        }
                                      },
                                      [
                                        _vm._t("suffix", function() {
                                          return [_c("i-chevron")]
                                        })
                                      ],
                                      2
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            : null
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.internalValue,
                        callback: function($$v) {
                          _vm.internalValue = $$v
                        },
                        expression: "internalValue"
                      }
                    },
                    "el-select",
                    _vm.$attrs,
                    false
                  ),
                  [
                    _vm.showEmptyOption
                      ? _c(
                          "el-option",
                          {
                            staticClass: "cog-select-option--empty",
                            attrs: { value: null }
                          },
                          [_vm._v(" ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.options, function(item, index) {
                      return _c(
                        "el-option",
                        {
                          key: item.value + index,
                          style: { order: index },
                          attrs: {
                            value: item.value,
                            label: item.displayValue || _vm.nbsp
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              class: {
                                "cog-image-item cog-image-item__dropdown":
                                  item.svg || item.image || item.choiceImage
                              }
                            },
                            [
                              item.image && !item.choiceImage
                                ? _c("div", { staticClass: "cog-flex" }, [
                                    _c("img", {
                                      staticClass:
                                        "cog-lookup-image cog-avatar",
                                      attrs: {
                                        src: item.image,
                                        alt: "",
                                        height: "50",
                                        width: "50"
                                      }
                                    })
                                  ])
                                : item.choiceImage
                                ? _c("div", { staticClass: "cog-flex" }, [
                                    _c("div", {
                                      staticClass: "cog-choice-image",
                                      style: {
                                        backgroundImage: `url(${item.choiceImage})`
                                      },
                                      attrs: { height: "50", width: "50" }
                                    })
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.svg
                                ? _c("c-generated-avatar", {
                                    attrs: { svg: item.svg }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    item.displayValue || item.value || _vm.nbsp
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }